import { inject, Injectable } from '@angular/core';
import { memo } from 'helpful-decorators';
import { some } from 'lodash-es';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CategoryQuery } from '../../../state/category/category.query';
import { ForecastTableGridDataInterface } from '../models/forecast-table-grid.model';

@Injectable({
  providedIn: 'root',
})
export class ForecastTableGridCategoryLoggingService {
  private categoryQuery = inject(CategoryQuery);

  @memo()
  isCategoryLoading(id: string) {
    return this.categoryQuery.ui.selectEntity(id, 'isLoading') as Observable<boolean>;
  }

  loadingCategories(categoryIds: ForecastTableGridDataInterface[]): Observable<boolean> {
    const categories = categoryIds.map((category) => {
      return this.isCategoryLoading(category.id);
    });

    return combineLatest(categories).pipe(
      map((loadingStatus) => {
        return some(loadingStatus, Boolean);
      })
    );
  }
}
